import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Register } from '@app/utils/type-registry';
import { CheckBoxFieldInput, CheckBoxFieldOutput } from '@trackback/widgets';
import { BaseFormControlWidgetComponent } from '../base-form-control-widget.component';
import { ParsePipe } from '../../pipes/parse.pipe';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AsyncPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Register('CheckBoxField')
@Component({
  selector: 'tb-check-box-field',
  templateUrl: './check-box-field.component.html',
  styleUrls: ['./check-box-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatCheckboxModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    AsyncPipe,
    ParsePipe,
  ],
})
export class CheckBoxFieldComponent
  extends BaseFormControlWidgetComponent<
    CheckBoxFieldInput,
    CheckBoxFieldOutput
  >
  implements OnInit
{
  @HostBinding('style.paddingTop')
  paddingTop?: string;

  @HostBinding('style.paddingRight')
  paddingRight?: string;

  @HostBinding('style.paddingBottom')
  paddingBottom?: string;

  @HostBinding('style.paddingLeft')
  paddingLeft?: string;
}
